// AutoMapper
import "reflect-metadata";
import {
    AutoMapper,
    ProfileBase,
    mapFrom,
    Mapper,
    convertUsing,
    Converter
} from "@nartc/automapper";

// Models
import { PolicyDto } from 'app/_mapper/policy.dto';
import { PolicyVm } from 'app/_mapper/policy.vm';

export class PolicyProfile extends ProfileBase {
    constructor(mapper: AutoMapper) {
        super();

        mapper
            .createMap(PolicyDto, PolicyVm)
            .forMember(
                d => d.isowncost,
                mapFrom(s => s.isOwnCost))
            .forMember(
                d => d.location,
                mapFrom(s => s.accidentLocation))
            .forMember(
                d => d.country.id,
                mapFrom(s => s.countryId))
            .forMember(
                d => d.client.id,
                mapFrom(s => s.clientId))
            .forMember(
                d => d.cause.ctyId,
                mapFrom(s => s.caseTypeId))
             .forMember(
               d => d.camality.calId,
               mapFrom(s => s.calamityId));
        mapper
            .createMap(PolicyVm, PolicyDto)
            .forMember(
                d => d.isOwnCost,
                mapFrom(s => s.isowncost))
            .forMember(
                d => d.accidentLocation,
                mapFrom(s => s.location))
            .forMember(
                d => d.countryId,
                mapFrom(s => s.country.id))
            .forMember(
                d => d.clientId,
                mapFrom(s => s.client.id))
            .forMember(
                d => d.caseTypeId,
                mapFrom(s => s.cause.ctyId))
            // .forMember(
            //     d => d.travelInsurancePolicies,
            //     mapFrom(s => s.selectedtravelPolicies))
            // .forMember(
            //     d => d.healthInsurancePolicies,
            //     mapFrom(s => s.selectedtravelPolicies))
            // ;
    }
}
